import { Patient } from '@pixacare/domain';
import { PagedCollection } from '@shared/models/pagination/paged-collection';
import { SortOrderStrategy } from '../../models/enums/sort-order-strategy.enum';

export type PatientsState = {
  patients: {
    [clientCode: string]: PagedCollection<{ [patientId: number]: Patient }>;
  };
  loadState: {
    [clientCode: string]: boolean;
  };
  order?: SortOrderStrategy;
};

export const initialPatientsState: PatientsState = {
  patients: {},
  order: null,
  loadState: {},
};
